/*
 * Returns a default image if the product image url is not available
 */
export function safeProductImageUrl(url?: string | null) {
  return (
    url ||
    `https://territory-assets.s3.amazonaws.com/photography-meals/coming-soon-bg.jpg`
  );
}
